import { render } from "./UsersPermission.vue?vue&type=template&id=3602d532&scoped=true"
import script from "./UsersPermission.vue?vue&type=script&lang=js"
export * from "./UsersPermission.vue?vue&type=script&lang=js"

import "./UsersPermission.vue?vue&type=style&index=0&id=3602d532&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3602d532"]])

export default __exports__